<template lang="pug">
.help-page__wrap
    .help-page__items(v-if="data.items")
        template(v-for="(item, index) in data.items" :key="index")
            v-help-card.help-page__item.flc(
                            :data-source="item")
</template>
<script>
import sourceMixin from './mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>